module.exports = __webpack_public_path__ + "img/Logo_celulares.861683f9.png";